import React from "react";
import { Star } from "lucide-react";

// Horizontal 5→1 star distribution bars. `breakdown` = { "5": n, ..., "1": n }.
export const RatingBreakdown = ({ breakdown, total, testId }) => {
  if (!breakdown) return null;
  const sum = total ?? Object.values(breakdown).reduce((a, b) => a + (b || 0), 0);
  return (
    <div className="space-y-1" data-testid={testId}>
      {[5, 4, 3, 2, 1].map((s) => {
        const n = breakdown[s] ?? breakdown[String(s)] ?? 0;
        const pct = sum > 0 ? Math.round((n / sum) * 100) : 0;
        return (
          <div key={s} className="flex items-center gap-2 text-xs" data-testid={testId ? `${testId}-${s}` : undefined}>
            <span className="inline-flex w-7 shrink-0 items-center gap-0.5 text-ink-soft">{s}<Star className="h-2.5 w-2.5 fill-amber-400 text-amber-400" /></span>
            <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-surface-200"><span className="block h-full rounded-full bg-amber-400" style={{ width: `${pct}%` }} /></span>
            <span className="w-6 shrink-0 text-right tabular-nums text-ink-muted">{n}</span>
          </div>
        );
      })}
    </div>
  );
};
